import React from 'react'
import {
  includes,
  startCase,
  snakeCase,
  FaCircle,
  removeAlertSubText
} from '@fareye/utils'
import { Flex, Span, styled, Grid, CheckBox, P, SearchSelect} from '@fareye/ui'
import { useTranslation } from '@fareye/common'
import { stateColorOption } from '@fareye/configs'
import { inTransitConstant } from '../../config/constants'
import { IKeyValue } from '@fareye/types'
const FilterItemsHeader = styled(Span)`
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 7px;
  color: #000000;
`
interface IFilterItemProps {
  optionKey: string
  optionValue: string
  checkedFilters: IKeyValue<string[]>
  handleChange: (isChecked: boolean, key: string, value: string) => void
  children?: any
}

const CheckboxItem = (props: IFilterItemProps) => {
  const { optionKey, optionValue, checkedFilters = {}, handleChange } = props
  const [isChecked, setIsChecked] = React.useState<boolean>(
    checkedFilters[optionKey]?.includes(optionValue) || false
  )
  React.useEffect(() => {
    setIsChecked(checkedFilters[optionKey]?.includes(optionValue) || false)
  }, [checkedFilters])
  return (
    <Span style={{ align: 'center' }}>
      <CheckBox
        type="checkbox"
        checked={isChecked}
        onChange={() => {
          handleChange(isChecked, optionKey, optionValue)
          setIsChecked(!isChecked)
        }}
        className={`${isChecked ? 'primary' : ''}`}
        variant="l"
        style={{
          margin: '0px 8px'
        }}
      />
      {props.children}
    </Span>
  )
}

const FilterItemLabel = styled(Span)`
  font-size: 14px;
  font-weight: 400;
  color: #212121;
  margin: 0px 4px;
`

export const getFilterCategoryListComponent = (
  item: string,
  prettyItem: string,
  filterOptions: Array<IKeyValue<string>>,
  checkedFilters: IKeyValue<string[]>,
  setCheckedFilters: React.Dispatch<React.SetStateAction<IKeyValue<string[]>>>,
  handleChange: (isChecked: boolean, key: string, value: string) => void,
  t: any
): React.ReactElement => {
  switch (prettyItem) {
    case 'inState':
      return (
        <>
          <FilterItemsHeader key={prettyItem}>
            {t(inTransitConstant[prettyItem] || prettyItem)}
          </FilterItemsHeader>
          {filterOptions.map(
            ({ label, value, key, count, prettyName }: any, index: number) => {
              return (
                <CheckboxItem
                  key={value}
                  optionKey={key}
                  optionValue={value}
                  checkedFilters={checkedFilters}
                  handleChange={handleChange}
                >
                  {includes(Object.keys(stateColorOption), value) ? (
                    <FaCircle
                      style={{
                        width: '6px',
                        height: '6px',
                        color: `${(stateColorOption as any)[value]}`,
                        margin: '4px 4px'
                      }}
                    />
                  ) : null}
                  <FilterItemLabel>{`${t(
                    startCase(label)
                  )} (${count})`}</FilterItemLabel>
                </CheckboxItem>
              )
            }
          )}
        </>
      )
    case 'alertEventTypes':
      return (
        <>
          <FilterItemsHeader key={prettyItem}>
            {t(inTransitConstant[prettyItem] || prettyItem)}
          </FilterItemsHeader>
          {filterOptions.map(
            ({ label, value, key, count, prettyName }: any, index: number) => {
              return (
                <CheckboxItem
                  key={value}
                  optionKey={key}
                  optionValue={value}
                  checkedFilters={checkedFilters}
                  handleChange={handleChange}
                >
                  <FilterItemLabel>{`${t(
                    removeAlertSubText(label)
                  )} (${count})`}</FilterItemLabel>
                </CheckboxItem>
              )
            }
          )}
        </>
      )
    case 'origin':
    case 'originName':
    case 'consignerName':
      return (
        <>
          <FilterItemsHeader key={prettyItem}>
            {t(inTransitConstant[prettyItem] || prettyItem)}
          </FilterItemsHeader>
          <SearchSelect
            options={filterOptions || []}
            isMulti
            placeholder={t(`Select ${inTransitConstant[prettyItem] || prettyItem}`)}
            value={filterOptions.filter(option => checkedFilters[item]?.includes(option.value))}
            onChange={ (selected: any) => {
              setCheckedFilters({...checkedFilters, [item]: selected?.map(({ value }: any) => value) || []})
            }}
          />
        </>
      )
    default:
      return (
        <>
          <FilterItemsHeader key={prettyItem}>
            {t(inTransitConstant[prettyItem] || prettyItem)}
          </FilterItemsHeader>
          {filterOptions.map(
            ({ label, value, key, count, prettyName }: any, index: number) => {
              return (
                <CheckboxItem
                  key={value}
                  optionKey={key}
                  optionValue={value}
                  checkedFilters={checkedFilters}
                  handleChange={handleChange}
                >
                  <FilterItemLabel>{`${t(
                    startCase(label)
                  )} (${count})`}</FilterItemLabel>
                </CheckboxItem>
              )
            }
          )}
        </>
      )
  }
}
